import {RootState} from 'redux/store'

export const selectSavedSearch = (state: RootState) => state.savedSearchRoot.savedSearch
export const selectSavedSearchSlice = (state: RootState) => state.savedSearchRoot
export const selectRecentSavedSearches = (state: RootState) =>
  state.savedSearchRoot.savedRecentSearches
